import { DisciplineReferralStudent } from './discipline-referral-student.model';
import { GeneralPreferences } from './../../shared-components/user-preferences/general-preferences.model';
import { Lookup } from './../../shared-components/lookup/lookup.model';
import { System } from '../../shared-components/System';
import { StudentAlerts } from '../../shared-components/models/student-alerts.model';

export class DisciplineReferral {

    // Class Functions
    get statusString(): string {
        if (this.Status) {
            return DisciplineReferral.StatusCodes[this.Status];
        } else {
            return '';
        }
    }

    get studentsFilterString(): string {
        let studentFilterString = '';
        if (this.Students) {
            this.Students.forEach(student => {
                if (studentFilterString) {
                    studentFilterString += ', ';
                }
                studentFilterString += student.formattedNameWithNumber(this.generalPreferences);
            });
        } else {
            const student = new DisciplineReferralStudent();
            Object.assign(student, this);
            studentFilterString = student.formattedNameWithNumber(this.generalPreferences);
        }
        return studentFilterString;
    }
    get studentsNumberFilterString(): string {
        let studentsNumberFilterString = '';
        if (this.Students) {
            this.Students.forEach(student => {
                if (studentsNumberFilterString) {
                    studentsNumberFilterString += ' ';
                }
                studentsNumberFilterString += student.formattedNumber(this.generalPreferences);
            });
        } else {
            const student = new DisciplineReferralStudent();
            Object.assign(student, this);
            studentsNumberFilterString = student.formattedNumber(this.generalPreferences);
        }
        return studentsNumberFilterString;
    }
    get studentsGradeFilterString(): string {
        let studentsGradeFilterString = '';
        if (this.Students) {
            this.Students.forEach(student => {
                if (studentsGradeFilterString) {
                    studentsGradeFilterString += ' ';
                }
                studentsGradeFilterString += student.Grade;
            });
        } else {
            const student = new DisciplineReferralStudent();
            Object.assign(student, this);
            studentsGradeFilterString = student.Grade;
        }
        return studentsGradeFilterString;
    }

    get processing(): boolean {
        return this.Status == 'A' || this.Status == 'S' || this.Status == 'C';
    }

    static StatusCodesV9: string[] = [
        'Accepted',
        'Submitted to Admin',
        'Classroom Action',
         'Closed',
        'No Action Needed',
        'Rejected',
        'In Progress'
    ];

    static StatusCodes: { [key: string]: string } = {
        'P': 'In Progress',
        'A': 'Accepted',
        'S': 'Submitted',
        'C': 'Completed',
        'N': 'No Action Needed',
        'R': 'Returned'
    };

    static StatusIds: { [key: string]: number } = {
        'P': 0,
        'A': 1,
        'S': 2,
        'C': 3,
        'N': 4,
        'R': 5
    };

    static InvolvingTypes: string[] = [
        'Student(s)',
        'Non-Student(s)',
        'Student(s) and Non-Student(s)',
        'Do Not Know'
    ];

    // Properties
    $id: string;
    AdminComment = '';
    AllowPBISOptions: boolean;
    Context = '';
    CourseId = 0;
    Date = new Date(System.junkDateString);
    Description = '';
    Disciplinarian?: any;
    EventComment = '';
    EventComments: string[];
    EventId: number;
    EventNumber: string;
    FirstName?: any;
    FunctionalMotivationId = '0';
    HideMultiEventComments: boolean;
    HomeroomTeacher = '';
    Id = 0;
    IncidentCodeId = '0';
    InterventionTypesDates?: string;
    InvolvingType = '0';
    IsDisciplineTeamMember: boolean;
    LastName?: any;
    Location?: string;
    LocationId?: string;
    MiddleName?: any;
    NickName?: any;
    PBISLocation?: any;
    PBISMotivation?: any;
    PBISOfficeManagedCount: any;
    PBISOthersInvolved?: any;
    PBISPriorInterventions?: any;
    PBISSelectedLocation: any = '';
    PBISSelectedMotivation: any = '';
    PBISSelectedOfficeManagedCount: any = '';
    PBISSelectedOthersInvolved: any = '';
    PBISSelectedPriorInterventions: any = '';
    PBISSelectedTimeRange = '';
    PBISTimeRange?: any;
    ReferredByUserId: number;
    ReportedBy?: string;
    RoomBus?: string;
    Schools?: Lookup[];
    ShowStudentLink: boolean;
    Site?: string;
    StaffName?: string;
    Status?: string;
    StatusId?: any;
    StudentId: number;
    StudentNumber?: any;
    Students?: DisciplineReferralStudent[];
    StudentsFromAllSchools: boolean;
    Time?: string;
    UnknownStudents: number;
    UseDisciplineTeams: boolean;
    UserManagedPBIS: boolean;
    Year?: any;
    Selected = false;
    ReportedByName: string;
    EventDescriptionMaxLength: number;
    EventCommentMaxLength: number;
    StudentCommentsMaxLength: number;
    AdministrativeCommentsMaxLength: number;
    ParentInformationMaxLength: number;
    LockReportedBy: boolean;
    LockAdministrativeComments: boolean;
    ParentInformation = '';
    StaffId: number;
    ReferralSiteId?: number;
    StudentAlerts: StudentAlerts[];

    // Local Properties
    generalPreferences: GeneralPreferences;

    // Class Functions
    get siteId() {
        return parseInt(this.Site, 10);
    }

    // Methods
    sortStudents() {
        if (this.Students) {
            this.Students.sort((a, b) => {

                // Ordering based on whether the student is known
                let aOrder = 0;
                let bOrder = 0;
                if (a.NonStudent) {
                    aOrder = 1;
                } else if (a.UnknownStudent) {
                    aOrder = 2;
                }
                if (b.NonStudent) {
                    bOrder = 1;
                } else if (b.UnknownStudent) {
                    bOrder = 2;
                }
                if (aOrder < bOrder) {
                    return -1;
                } else if (aOrder > bOrder) {
                    return 1;
                }

                // Ordering alphabetically
                else {
                    return a.formattedNameWithNumber(this.generalPreferences).localeCompare(b.formattedNameWithNumber(this.generalPreferences));
                }
            });
        }
    }
}
